var _rect, _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagTrk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15689_296764",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 35C27.3888 35 35 27.3888 35 18C35 8.61116 27.3888 1 18 1C8.61116 1 1 8.61116 1 18C1 27.3888 8.61116 35 18 35Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15689_296764)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15689_296764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4 1H47V35H-4V1Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6585 18L27.347 15.5021L22.595 22.042V13.958L27.347 20.4979L19.6585 18ZM20.1827 22.5452C19.1979 24.1014 17.7343 25.2957 16.0123 25.9484C14.2902 26.601 12.4027 26.6767 10.6339 26.164C8.86503 25.6514 7.31055 24.5781 6.20433 23.1058C5.09811 21.6334 4.5 19.8416 4.5 18C4.5 16.1584 5.09811 14.3666 6.20433 12.8942C7.31055 11.4219 8.86503 10.3486 10.6339 9.83597C12.4027 9.32332 14.2902 9.39901 16.0123 10.0516C17.7343 10.7043 19.1979 11.8986 20.1827 13.4548C19.2631 12.4315 18.0547 11.7112 16.7171 11.389C15.3796 11.0669 13.9757 11.1581 12.6911 11.6505C11.4064 12.1429 10.3013 13.0134 9.52179 14.1471C8.74225 15.2807 8.32492 16.6242 8.32492 18C8.32492 19.3758 8.74225 20.7193 9.52179 21.8529C10.3013 22.9866 11.4064 23.8571 12.6911 24.3495C13.9757 24.8419 15.3796 24.9331 16.7171 24.611C18.0547 24.2888 19.2631 23.5685 20.1827 22.5452Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15689_296764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 34,
    fill: "white",
    transform: "translate(-4 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTrk);
export default __webpack_public_path__ + "static/media/flagTRK.4e7b6a3849154ae1368078a83b81748f.svg";
export { ForwardRef as ReactComponent };